import _ from 'lodash';
import { Notification } from 'element-ui';
// import notification from 'ant-design-vue/es/notification';

export const handleAPISuccess = (message, description) => {
    Notification.success({
        title: message,
        message: description,
    });
    // notification.success({
    //     message,
    //     description,
    // });
};

export const notifyError = (e) => {
    const showError = (message) => {
        Notification.error({
            title: '錯誤',
            message,
            duration: 10000,
        });
    };

    const responseData = _.get(e, 'response.data');
    if (responseData instanceof Blob) {
        responseData.text()
            .then((text) => JSON.parse(text))
            .then((jsonData) => {
                showError(jsonData.message || e.message || e.toString());
            })
            .catch((blobError) => {
                console.warn('Failed to parse blob response:', blobError);
                showError(e.message || e.toString());
            });
    } else {
        const errorMessage = _.get(e, 'response.data.message', e.message || e.toString());
        showError(errorMessage);
    }
};

export const handleAPIError = (e) => {
    notifyError(e);
    throw e;
};

export const deepTransformId = (ret) => {
    try {
        const raw = JSON.stringify(ret);
        return JSON.parse(raw.replace(/"_id"/g, '"id"'));
    } catch {
        throw new Error('deep transform id fail');
    }
};
